import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentId } from '@gandi/redux-sharing';
import { useTranslator } from '@gandi/translate';
import { Base, Block, BlockHeading, HeadingIcon, Text, Button, BlockButtons, BlockContent } from '@gandi/ui';
import { selectMyActiveCard } from '../../../modules/mycards/resource';
import { selectPrepaidAmount } from '../../../modules/prepaid';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "markdownContent": "index-markdownContent_3CyPy",
  "icon": "index-icon_3c6mp"
};
export default function OrderStatus({
  order,
  status
}) {
  const {
    __
  } = useTranslator();
  const sharingId = useSelector(selectCurrentId);
  const activeCard = useSelector(state =>
  // $FlowFixMe[incompatible-call]
  selectMyActiveCard(state, {
    sharingId
  }));
  const amountOnPrepaid = useSelector(state =>
  // $FlowFixMe[incompatible-call]
  selectPrepaidAmount(state, {
    sharingId
  }));
  const hasNoActiveCard = !activeCard;
  const hasActiveCard = !!activeCard;
  const hasInsufficientPrepaidAmount = Number.isFinite(Number(amountOnPrepaid)) && Number(amountOnPrepaid) < order.price_after_taxes;
  let translations = {
    icon: '',
    title: '',
    content: ''
  };
  switch (order.payment_type) {
    case 'transfer':
      translations = {
        icon: 'arrowRight',
        title: __('You can proceed to bank transfer.'),
        // $FlowFixMe[incompatible-type]
        content: __("Precise the order number **%(transaction)s** in the transfer's comment " + 'field & the amount **%(amount)s**.', {
          withMarkdown: true,
          amount: order.price_after_taxes_label,
          transaction: order.id
        })
      };
      break;
    case 'check':
      translations = {
        icon: 'arrowRight',
        title: __('Complete your order by sending your check.'),
        // $FlowFixMe[incompatible-type]
        content: __('Send your check of **%(amount)s** payable to **%(bankName)s** with ' + 'your order number **%(transaction)s** in the back of it. ' + 'You can send it to Gandi by mail.', {
          withMarkdown: true,
          amount: order.price_after_taxes_label,
          transaction: order.id,
          bankName: order.bu.bank.name
        })
      };
      break;
    case 'mandate':
      translations = {
        icon: 'arrowRight',
        title: __('Print, sign and send us your purchase order.'),
        // $FlowFixMe[incompatible-type]
        content: __('Print the proforma and sign it to make a purchase order. ' + 'You can send it by email, mail or fax. After our validation you may ' + 'proceed to the payment. if you want to use your own purchase order, ' + 'precise the order number **%(transaction)s** & the amount **%(amount)s**', {
          withMarkdown: true,
          amount: order.price_after_taxes_label,
          transaction: order.id
        })
      };
      break;
    case 'deferred':
      translations = {
        icon: 'successWire',
        title: __('Congratulations! Your order has been registered.'),
        // $FlowFixMe[incompatible-type]
        content: __('It will be processed when your payment is validated. You will receive a confirmation email when your order is complete.', {
          withMarkdown: true
        })
      };
      break;
    case 'prepaid':
      {
        let prepaidIcon = 'successWire';
        let prepaidtitle = __('Congratulations! Your order has been registered.');
        let prepaidContent = __('It is confirmed and will be processed immediately. You will receive a confirmation e-mail when your order is complete.', {
          withMarkdown: true
        });
        if (order.status === 'unpaid') {
          if (hasNoActiveCard || hasInsufficientPrepaidAmount) {
            prepaidIcon = 'warningWire';
            prepaidtitle = __('Pay your order now to complete the transaction');
          }
          if (hasNoActiveCard) {
            prepaidContent = __("You don't have any default payment card set on your account.", {
              withMarkdown: true
            });
          }
          if (hasInsufficientPrepaidAmount && hasActiveCard) {
            prepaidContent = __('Your prepaid account balance is insufficient to proceed with your order.', {
              withMarkdown: true
            });
          }
        }
        translations = {
          icon: prepaidIcon,
          title: prepaidtitle,
          // $FlowFixMe[incompatible-type]
          content: prepaidContent
        };
        break;
      }
    case 'bitcoin':
      translations = {
        icon: 'successWire',
        title: __('Your order is awaiting validation.'),
        // $FlowFixMe[incompatible-type]
        content: __('It will be processed once it is validated by Bitpay, which may take several hours. ' + 'You will receive a confirmation email when your order is complete.', {
          withMarkdown: true
        })
      };
      break;
    default:
      if (status === 'delayed') {
        translations = {
          icon: 'arrowRight',
          title: __('Your order is awaiting validation.'),
          // $FlowFixMe[incompatible-type]
          content: __('It will be processed once it is validated, which may take several ' + 'hours with the payment method you chose. ' + 'You will receive a confirmation email when your order is complete.', {
            withMarkdown: true
          })
        };
      } else {
        translations = {
          icon: 'successWire',
          title: __('Congratulations! Your order has been registered.'),
          // $FlowFixMe[incompatible-type]
          content: __('It is confirmed and will be processed immediately. You will receive a confirmation e-mail when your order is complete.', {
            withMarkdown: true
          })
        };
      }
      break;
  }
  return /*#__PURE__*/_jsxs(Block, {
    children: [/*#__PURE__*/_jsxs(BlockHeading, {
      fontSize: "m",
      children: [/*#__PURE__*/_jsx(HeadingIcon, {
        name: translations.icon,
        theme: translations.icon === 'successWire' ? 'success' : 'warning'
      }), translations.title]
    }), /*#__PURE__*/_jsxs(BlockContent, {
      children: [/*#__PURE__*/_jsx(Base, {
        tagName: "p",
        marginTop: "none",
        marginBottom: "small",
        className: styles.markdownContent,
        dangerouslySetInnerHTML: translations.content
      }), /*#__PURE__*/_jsxs(Base, {
        flex: true,
        flexJustifyBetween: true,
        flexWrap: true,
        gap: "xsmall",
        marginBottom: "small",
        children: [/*#__PURE__*/_jsx(Text, {
          children: __('Transaction number')
        }), ' ', /*#__PURE__*/_jsx(Text, {
          weight: "semibold",
          children: order.id
        })]
      }), /*#__PURE__*/_jsxs(Base, {
        flex: true,
        flexJustifyBetween: true,
        flexWrap: true,
        gap: "xsmall",
        children: [/*#__PURE__*/_jsx(Text, {
          children: __('Total')
        }), /*#__PURE__*/_jsx(Text, {
          weight: "semibold",
          children: order.price_after_taxes_label
        })]
      })]
    }), order.payment_type === 'prepaid' && order.status === 'unpaid' && (hasNoActiveCard || hasInsufficientPrepaidAmount) && /*#__PURE__*/_jsx(BlockButtons, {
      children: /*#__PURE__*/_jsx(Button, {
        to: `/prepaid?amount=${order.price_after_taxes}`,
        kind: "outline",
        small: true,
        children: __('Pay now')
      })
    })]
  });
}